import type { LoginConfig } from 'structure/login';
import type { Feature } from 'util/stdtypes';
import { makeAssetUrl } from 'util/util';

export const ZDFLoginScreenFeature: Feature<LoginConfig, {}> = {
    name: 'ZDF - Login Screen',
    key: 'zdfloginscreen',
    providesConfig: {
        loginHeadingLabel: 'Join the discussion',
        loginSubHeadingLabel: 'You are registering for the test operation of our conversation service “ZDFspaces”.',
        showCookieNotice: false,
        loginPreviewImage: makeAssetUrl('images/ZDF_logo.svg'),
        loginPreviewImageAdmin: makeAssetUrl('images/ZDF_logo.svg'),
        showDisplayNameBubble: false,
    },
};
